import React from 'react';
import './ListOfForms.scss';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import ListOfFormTable from "./ListOfFormTable";

const ListOfForms = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className='list_of_forms'>
              <HeaderPrint
                englishTitle={"List  of  forms"}
                persianTitle={"فهرست فرم ها"}
                color={"#1B9C85"}
              />
              <div className='form_info'>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>کاربـر :</span>
                    <span className='iransans'>{item.user}</span>
                  </div>
                </div>
                <div className='info_box'>
                  <div className='box_child'>
                    <span className='iransans'>تاریخ :</span>
                    <span className='iransans'>{item.date}</span>
                  </div>
                </div>
              </div>
              <ListOfFormTable tableData={item.table}/>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default ListOfForms;